import React, { useRef, useState, useEffect, useCallback } from 'react';
import {
  Datagrid,
  ListBase,
  ListToolbar,
  Pagination,
  useListContext,
  useRefresh,
  Title,
  ListContextProvider,
} from 'react-admin';

import { Card, makeStyles, Divider, Tabs, Tab } from '@material-ui/core';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DescriptionIcon from '@material-ui/icons/Description';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import { DialogoConfirmacao } from '../../Components';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { STATUS_ATIVO, STATUS_INATIVO } from '../../utils/constants';
import { PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR } from '../../utils/dadosTelas';
import Actions from './ActionsList';
import DialogoCreateEdit from './DialogoCreateEdit';
import DialogoDeletarCategoriaTransacao from './DialogoDeletar';
//import ActionsField from './Fields/ActionsField';
import ColorField from './Fields/ColorField';
import IconField from './Fields/IconField';
import StatusField from './Fields/StatusField';
import ValorField from './Fields/ValorField';
import Filter from './Filter';

const useStylesDatagrid = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: '#f8f8f8',
    padding: '10px',
    color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));

const tabs = [
  { id: 'ativos', name: 'Ativos' },
  { id: 'inativos', name: 'Inativos' },
];

const DataGridLocal = ({
  handleEdit = () => {},
  handleDelete = () => {},
  handleDescription = () => {},
  ...props
}) => {
  const classes = useStylesDatagrid();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  return (
    <>
      <Datagrid {...props} bulkActionButtons={false}>
        <TextoField
          source="nome"
          label="Nome"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
        />
        <IconField
          source="icon"
          label="Icone"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
        />
        <ColorField
          source="color"
          label="Cor"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
        />

        <StatusField
          source="contabiliza_no_lucro"
          label="Lucro"
          sortable={false}
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
        />
        <ValorField
          source="totalTransacoesMesPago"
          label="Transações Pagas"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
        />
        <ValorField
          source="totalTransacoesMesNaoPago"
          label="Transações Não Pagas"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
        />
        <ValorField
          source="totalTransacoesMes"
          label="Transações Total"
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          sortable={false}
        />
        <ActionsField
          source="valor"
          textAlign="right"
          label="Ações"
          sortable={false}
          headerClassName={classes.dataHeader}
          cellClassName={classes.dataCell}
          /*  tipo={filterValues.tipo}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          handleDescription={handleDescription} */
          actions={[
            {
              key: 'relatorios',
              title: 'Relatórios',
              icon: <DescriptionIcon />,
              onClick: (rec) => handleDescription(rec),
              show: () => true,
              disabled: () => false,
            },
            {
              key: 'editar',
              title: 'Editar',
              icon: <EditOutlinedIcon />,
              onClick: (rec) => handleEdit(rec),
              show: (rec) => rec.status === STATUS_ATIVO,
              disabled: (rec) => (rec.gerenciado ? true : false),
            },
            /*           {
              key: 'ativar',
              title: 'Ativar',
              icon: <CheckCircleOutlineIcon />,
              onClick: (rec) => handleAtivar(rec),
              show: (rec) => rec.status === STATUS_INATIVO,
              disabled: (rec) => rec.gerenciado === true,
            },
            {
              key: 'desativar',
              title: 'Desativar',
              icon: <ClearIcon />,
              onClick: (rec) => handleDesativar(rec),
              show: (rec) => rec.status === STATUS_ATIVO,
              disabled: (rec) => rec.gerenciado === true,
            }, */
            {
              key: 'excluir',
              title: 'Excluir',
              icon: <DeleteOutlineIcon />,
              onClick: (rec) => handleDelete(rec),
              show: (rec) => rec.status === STATUS_INATIVO,
              disabled: (rec) => (rec.gerenciado ? true : false),
            },
          ]}
        />
      </Datagrid>
    </>
  );
};

//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoDeletar = useRef(null);
  const classes = useStylesDatagrid();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const refDialogoConfirmacao = useRef(null);
  const [ativos, setAtivos] = useState([]);
  const [inativos, setInativos] = useState([]);
  const [dialogo, setDialogo] = useState({ open: false, id: null, tipo: 'Despesa' });

  const create = (tipo) => {
    setDialogo({ open: true, id: null, tipo });
  };

  const edit = (rec) => {
    setDialogo({ open: true, id: rec.id, tipo: rec.tipo });
  };

  function handleAtivar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Reativação de Categoria de transação',
        'Deseja realmente reativar este categoria de transação?',
        { id, codigo: 1 },
      );
    }
  }

  function handleDesativar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Desativação de Categoria de transação',
        'Deseja realmente desativar este categoria de transação?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Categoria de transação',
        'Deseja deletar permanentemente este categoria de transação?',
        { id, codigo: 3 },
      );
    }
  }

  async function ativar(id) {
    await api.put(`/categorias_transacao/status/ativar/${id}`);
    handleClose();
  }

  async function desativar(id) {
    await api.put(`/categorias_transacao/status/inativar/${id}`);
    handleClose();
  }

  async function deletar(id) {
    await api.put(`/categorias_transacao/status/deletar/${id}`);
    handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        ativar(id);
        break;
      case 2:
        desativar(id);
        break;
      case 3:
        deletar(id);
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (ids && ids !== filterValues.status) {
      switch (filterValues.status) {
        case STATUS_ATIVO:
          setAtivos(ids);
          break;
        case STATUS_INATIVO:
          setInativos(ids);
          break;
        default:
          break;
      }
    }
  }, [ids, filterValues.status]);

  const handleChange = useCallback(
    (event, value) => {
      if (setFilters) {
        setFilters(
          {
            ...filterValues,
            status: value === 'ativos' ? STATUS_ATIVO : STATUS_INATIVO,
          },
          displayedFilters,
        );
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleClose = () => {
    refresh();
  };

  return (
    <>
      <Title title="Categorias Transações" />
      <ListToolbar
        filters={<Filter />}
        actions={<Actions handleCriar={create} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px', marginTop: '30px' }} {...props}>
        <Divider />
        <Tabs
          variant="fullWidth"
          centered
          value={filterValues.status === STATUS_ATIVO ? tabs[0].id : tabs[1].id}
          indicatorColor="primary"
          onChange={handleChange}
        >
          {tabs.map((choice) => (
            <Tab key={choice.id} label={choice.name} value={choice.id} />
          ))}
        </Tabs>
        <Divider />
        <div>
          {filterValues.status === STATUS_ATIVO && (
            <ListContextProvider value={{ ...listContext, ids: ativos }}>
              <Datagrid {...props} bulkActionButtons={false}>
                <TextoField
                  source="nome"
                  label="Nome"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <IconField
                  source="icon"
                  label="Icone"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ColorField
                  source="color"
                  label="Cor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />

                <StatusField
                  source="contabiliza_no_lucro"
                  label="Lucro"
                  sortable={false}
                  headerClassName={classes.statusHeader}
                  cellClassName={classes.statusCell}
                />
                <ValorField
                  source="totalTransacoesMesPago"
                  label="Transações Pagas"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ValorField
                  source="totalTransacoesMesNaoPago"
                  label="Transações Não Pagas"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ValorField
                  source="totalTransacoesMes"
                  label="Transações Total"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  /*  tipo={filterValues.tipo}
                  handleEdit={edit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar}
                  handleDescription={() => {}} */
                  actions={[
                    {
                      key: 'relatorios',
                      title: 'Relatórios',
                      icon: <DescriptionIcon />,
                      onClick: () => {},
                      show: () => true,
                      disabled: () => false,
                    },
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => edit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'excluir',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
          {filterValues.status === STATUS_INATIVO && (
            <ListContextProvider value={{ ...listContext, ids: inativos }}>
              <Datagrid {...props} bulkActionButtons={false}>
                <TextoField
                  source="nome"
                  label="Nome"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                />
                <IconField
                  source="icon"
                  label="Icone"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ColorField
                  source="color"
                  label="Cor"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />

                <StatusField
                  source="contabiliza_no_lucro"
                  label="Lucro"
                  sortable={false}
                  headerClassName={classes.statusHeader}
                  cellClassName={classes.statusCell}
                />
                <ValorField
                  source="totalTransacoesMesPago"
                  label="Transações Pagas"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ValorField
                  source="totalTransacoesMesNaoPago"
                  label="Transações Não Pagas"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ValorField
                  source="totalTransacoesMes"
                  label="Transações Total"
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  sortable={false}
                />
                <ActionsField
                  source="valor"
                  textAlign="right"
                  label="Ações"
                  sortable={false}
                  headerClassName={classes.dataHeader}
                  cellClassName={classes.dataCell}
                  /*            tipo={filterValues.tipo}
                  handleEdit={edit}
                  handleAtivar={handleAtivar}
                  handleDesativar={handleDesativar}
                  handleDeletar={handleDeletar}
                  handleDescription={() => {}} */
                  actions={[
                    {
                      key: 'relatorios',
                      title: 'Relatórios',
                      icon: <DescriptionIcon />,
                      onClick: () => {},
                      show: () => true,
                      disabled: () => false,
                    },
                    {
                      key: 'editar',
                      title: 'Editar',
                      icon: <EditOutlinedIcon />,
                      onClick: (rec) => edit(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'ativar',
                      title: 'Ativar',
                      icon: <CheckCircleOutlineIcon />,
                      onClick: (rec) => handleAtivar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'desativar',
                      title: 'Desativar',
                      icon: <ClearIcon />,
                      onClick: (rec) => handleDesativar(rec),
                      show: (rec) => rec.status === STATUS_ATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                    {
                      key: 'excluir',
                      title: 'Excluir',
                      icon: <DeleteOutlineIcon />,
                      onClick: (rec) => handleDeletar(rec),
                      show: (rec) => rec.status === STATUS_INATIVO,
                      disabled: (rec) => (rec.gerenciado ? true : false),
                    },
                  ]}
                />
              </Datagrid>
            </ListContextProvider>
          )}
        </div>
        <TransacoesPagination />
      </Card>
      <DialogoCreateEdit
        open={dialogo.open}
        id={dialogo.id}
        tipo={dialogo.tipo}
        onClose={() => {
          setDialogo({ open: false, id: null, tipo: '' });
          handleClose();
        }}
      />
      <DialogoDeletarCategoriaTransacao
        ref={refDialogoDeletar}
        handleClose={handleClose}
      />
      <DialogoConfirmacao
        ref={refDialogoConfirmacao}
        handleConfirma={handleConfirma}
      />
    </>
  );
};

const ContainerMyList = ({ ...props }) => (
  <ListBase {...props}>
    <MyList />
  </ListBase>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_CATEGORIAS_TRANSACOES_LISTAR}>
    <ContainerMyList
      {...props}
      title=""
      filterDefaultValues={{
        tipo: 'Despesa',
        periodo: { ano: new Date().getFullYear(), mes: new Date().getMonth() },
        status: STATUS_ATIVO,
      }}
      component="div"
      bulkActionButtons={false}
      sort={{ field: 'nome', order: 'DESC' }}
      pagination={<TransacoesPagination />}
      perPage={200}
    />
  </ProtegerPagina>
);

export default List2;
